import { CommonModule, NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SelfPrintPersona } from '@app/v2/event/types/settings.type'

@Component({
  selector: 'app-self-print-persona-card',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './self-print-persona-card.component.html',
  styleUrl: './self-print-persona-card.component.scss'
})
export class SelfPrintPersonaCardComponent {
  public readonly personas = input.required<SelfPrintPersona[]>()

  public readonly selfPrintToggled = output<{ id: number; enabled: boolean }>()
  public readonly limitEdited = output<void>()

  private readonly _limitNavKeys = new Set(['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'])

  public onSelfPrintToggle(personaId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked
    this.selfPrintToggled.emit({ id: personaId, enabled: checked })
  }

  /**
   * Handles the keydown event for the limit input
   * @param event {KeyboardEvent} - The keyboard event
   */
  public onLimitKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey || event.altKey) return
    if (this._limitNavKeys.has(event.key)) return
    if (event.key.length === 1 && /^\d$/.test(event.key)) return
    event.preventDefault()
  }

  /**
   * Handles the paste event for the limit input
   * @param event {ClipboardEvent} - The clipboard event
   * @param persona {SelfPrintPersona} - The persona
   */
  public onLimitPaste(event: ClipboardEvent, persona: SelfPrintPersona): void {
    event.preventDefault()
    const text = event.clipboardData?.getData('text/plain') ?? ''
    const digits = text.replace(/\D/g, '')
    if (digits === '') {
      persona.limitControl.setValue(null)
    } else {
      if (Number.isSafeInteger(Number(digits))) persona.limitControl.setValue(Number(digits))
    }
    persona.limitControl.markAsDirty()
    persona.limitControl.updateValueAndValidity({ emitEvent: false })
    this.onLimitInput()
  }

  /**
   * Handles the wheel event for the limit input
   * @param event {WheelEvent} - The wheel event
   */
  public onLimitWheel(e: WheelEvent): void {
    ;(e.target as HTMLInputElement).blur()
  }

  /**
   * Handles the input event for the limit input
   */
  public onLimitInput(): void {
    this.limitEdited.emit()
  }
}
